// extracted by mini-css-extract-plugin
module.exports = {"flashContent":"styles_flashContent__moQgN","flashContent__dismissible":"styles_flashContent__dismissible__Yn1uw","flashContent_center":"styles_flashContent_center__cGXtE"};